import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/2899785a-91ab-4c85-8a4c-af51ab6b7143";
export const REGISTER_URL = "https://a.ntrk2.com/6b88cc51-a469-4f5e-8362-a6b7b5f8b98a";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://brbig.loadprkw2a.com/download?openExternalBrowser=1&id=ixx82w62ln3kb88";

export * from "./codes";
export * from "./context";
